export { DetachResponsibleFromLead } from './DetachResponsibleFromLead.main';
